import FileTransferTask from "./FileTransferTask";

/**
 * @class InfoDialog
 */
export default class FileTransferInTask extends FileTransferTask {
    /**
     * @param {String}          name
     * @param {String}          format
     * @param {Object}          formatOptions
     * @param {String}          protocol
     * @param {Object}          protocolOptions
     * @param {Number}          interval
     * @param {String | null}   notification
     */
    constructor(name, format, formatOptions, protocol, protocolOptions, interval, notification) {
        super(name, format, formatOptions, protocol, protocolOptions);

        this._interval = interval;
        this._intervalHours = Math.floor(interval / 60 / 60);
        this._intervalMinutes = Math.floor((interval / 60) % 60);
        this._intervalSeconds = interval % 60;
        this._notification = notification;
    }

    /**
     * @return {Number}
     */
    get interval() {
        return this._interval;
    }

    /**
     * @return {Number}
     */
    get intervalHours() {
        return this._intervalHours;
    }

    /**
     * @return {Number}
     */
    get intervalMinutes() {
        return this._intervalMinutes;
    }

    /**
     * @return {Number}
     */
    get intervalSeconds() {
        return this._intervalSeconds;
    }

    /**
     * @return {String | null}
     */
    get notification() {
        return this._notification;
    }

    /**
     * @return  {Object}
     */
    formatTask = () => {
        return {
            name: this._name,
            format: this._format,
            format_options: this._formatOptions,
            protocol: this._protocol,
            protocol_options: this._protocolOptions,
            interval: this._interval,
            notification: this._notification
        };
    };
}
